import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { applySentryRouteContext } from "./sentry";

export function SentryRouteObserver() {
  const location = useLocation();
  useEffect(() => {
    applySentryRouteContext(location.pathname, location.search);
  }, [location.pathname, location.search]);
  return null;
}
